/** Rutas de banda con guía Driver.js (botón «Guía de uso» en AppLayout). */
export const BANDA_TOUR_PATHS = [
  '/banda/perfil',
  '/banda/calendario',
  '/banda/eventos',
  '/banda/buscar',
  '/banda/mensajes',
  '/banda/repertorio',
  '/banda/documentos',
  '/banda/musicos',
  '/banda/formaciones',
  '/banda/actuaciones',
  '/banda/ensayos',
  '/banda/contactos',
  '/banda/encuestas-consultas',
  '/banda/metricas',
  '/banda/objetivos',
  '/banda/permisos',
];

export function hasBandaTour(pathname) {
  return BANDA_TOUR_PATHS.includes(pathname);
}

export function tourStep(id, title, description, side = 'bottom') {
  return {
    element: `[data-tour="${id}"]`,
    popover: {
      title,
      description,
      side,
      align: 'center',
    },
  };
}
